import { Colors, Icon } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface SkillItemProps {
    /** Skill identifier */
    id: string;
    /** Skill display name */
    name: string;
    /** Skill description text */
    description: string;
    /** Number of questions associated */
    questions: number;
    /** Callback when remove button is clicked */
    onRemove: (id: string) => void;
}

export const SkillItem = ({ id, name, description, questions, onRemove }: SkillItemProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div
            className={
                'relative flex items-center justify-between border-b border-gray-100 px-12 py-5 last:border-b-0'
            }
        >
            <div className={'flex min-w-0 flex-1 flex-col gap-1'}>
                <div className={'flex flex-col items-start gap-3 sm:flex-row sm:items-center'}>
                    <h5 className={'text-sm font-medium text-gray-900'}>{name}</h5>

                    <div
                        className={
                            'bg-secondary/10 flex items-center justify-center rounded-full px-2 py-1'
                        }
                    >
                        <span className={'text-secondary text-[10px] leading-4 font-medium'}>
                            {t('managerAssessmentSetup.questionCount', { count: questions })}
                        </span>
                    </div>
                </div>

                {description && (
                    <p className={'max-w-[600px] text-xs leading-normal text-gray-900/60'}>
                        {description}
                    </p>
                )}
            </div>

            <button
                type={'button'}
                onClick={() => onRemove(id)}
                className={
                    'ml-4 flex h-[30px] w-[30px] shrink-0 items-center justify-center transition-opacity hover:opacity-80'
                }
                aria-label={`Remove ${name}`}
                data-testid={`remove-skill-${id}`}
            >
                <Icon
                    name={'essential-close-circle'}
                    size={30}
                    color={Colors.ERROR}
                />
            </button>
        </div>
    );
};
